<i18n>
{
  "en": {
    "consumptionPerPerson": "Diners per plate",
    "commercialName": "Commercial name of the master product",
    "commercialDescription": "Commercial description of the mater product",
    "longCommercialDescription": "Long commercial description of the master product",
    "emptyStringError": "This field cannot be empty"
  },
  "es": {
    "commercialName":  "Nombre comercial del producto maestro",
    "commercialDescription":  "Descripcion comercial del producto maestro",
    "longCommercialDescription":  "Descripcion larga comercial del producto maestro",
    "emptyStringError": "Este campo no puede estar vacio"
  }
}
</i18n>
<template>
    <div>
      <v-chip-group
        mandatory
        active-class="primary"
        @change="handleSelectLanguage"
      >
        <v-chip
          v-for="(modelLanguage) in modelLanguageList"
          small
          :key="modelLanguage.name"
          :value="modelLanguage"
        >
          {{ modelLanguage.name }} <span class="required">*</span>
        </v-chip>
      </v-chip-group>
      <div
        v-for="(modelLanguage, index) in modelLanguageList"
        :key="index"
        v-show="selectedLanguage && modelLanguage.guid === selectedLanguage.guid"
        class="pb-0 mb-0">
          <v-text-field
            :value="textValue[modelLanguage.guid].commercialName"
            :label="$t('commercialName')"
            :key="`commercialName-${index}`"
            @change="(e) => handlerInput(e, modelLanguage.guid, 'commercialName')"
            class="required"
            :rules="commercialNameRules"
          />
          <v-text-field
            :value="textValue[modelLanguage.guid].commercialDescription"
            :label="$t('commercialDescription')"
            :key="`commercialDescription-${index}`"
            @change="(e) => handlerInput(e, modelLanguage.guid, 'commercialDescription')"
          />
          <v-text-field
            :value="textValue[modelLanguage.guid].longCommercialDescription"
            :label="$t('longCommercialDescription')"
            :key="`longCommercialDescription-${index}`"
            @change="(e) => handlerInput(e, modelLanguage.guid, 'longCommercialDescription')"
          />
      </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import { notEmptyString } from '@core/helpers/formValidators';

@Component
@MapGetters(['modelLanguageList'])
export default class ProductMasterFieldLanguages extends Vue {
  @Prop({ type: Object, required: true }) value;

  textValue = {};

  selectedLanguage = {};

  get commercialNameRules() {
    return [notEmptyString(this.$t('emptyStringError'))];
  }

  handleSelectLanguage(languages) {
    this.selectedLanguage = languages;
  }

  handlerInput(value, languageGuid, field) {
    this.textValue[languageGuid][field] = value;
    this.$emit('input', this.textValue);
  }

  @Watch('modelLanguageList', { immediate: true })
  async onModelLanguageList(newValue) {
    if (newValue) {
      newValue.forEach((each) => {
        this.textValue[each.guid] = {
          modelLanguage: each.guid,
          commercialName: '',
          commercialDescription: '',
          longCommercialDescription: '',
        };
      });
    }
  }

  @Watch('value', { immediate: true })
  onValue(newValue) {
    if (newValue) {
      Object.keys(newValue).forEach((key) => {
        this.textValue[key] = newValue[key];
      });
    }
  }
}
</script>
<style scoped>
.required {
  color: #ff0c11;
  margin-left: 2px;
}
</style>
